import { combineReducers } from '@reduxjs/toolkit'
import auth from './authentication'
import notification from './notification'

export const rootReducer = combineReducers({
  auth,
  notification
})
